<template>
  <div>
    <v-card class="pa-3">
      <v-layout justify-end>
        <v-btn flat icon @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-layout>
      <v-layout justify-end class="mb-2">
        <v-btn depressed color="primary" @click="printThis">
          <em class="fas fa-download" style="font-size: 18px" />
          <span class="ml-1">{{ $t('Download') }}</span>
        </v-btn>
      </v-layout>
      <div ref="printcontent" style="width: 900px; padding: 4px">
        <template v-if="rawData">
          <div style="border: 1px solid #000" class="pa-2 mb-4">
            <Page1 :data="localData.page_1" :read-only="true" />
          </div>
          <div style="border: 1px solid #000" class="pa-2">
            <Page2 :data="localData.page_2" :read-only="true" />
          </div>
        </template>
      </div>
    </v-card>
  </div>
</template>

<script>
import * as html2canvas from 'html2canvas'
import Page1 from './Form/Page1.vue'
import Page2 from './Form/Page2.vue'
export default {
  components: {
    Page1,
    Page2
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      output: null,
      rawData: null,
      currentPage: 1,
      localData: {
        page_1: {
          id: '',
          drinker_name: '',
          is_fill_date: '',
          drinker_gender: '',
          drinker_year: '',
          score: '',
          risk: '',
          motivation_behavior_change: '',
          is_stop_drink_in_one_year: null,
          low_risk_group: null,
          high_risk_group: null,
          filler_name: '',
          filler_relation: '',
          assessor_name: ''
        },
        page_2: {
          physical_symptoms: null,
          physical_symptoms_detail: '',
          risk_self_harm: null,
          risk_self_harm_detail: '',
          addict_alcohol: null,
          addict_alcohol_detail: '',
          addict_stimulants: null,
          addict_stimulants_detail: '',
          addict_marijuana_kratom: null,
          addict_marijuana_kratom_detail: '',
          addict_etc: null,
          addict_etc_detail: '',
          stress: null,
          stress_detail: '',
          depressed_mood: null,
          depressed_mood_detail: '',
          sleeping_problem: null,
          sleeping_problem_detail: '',
          weight_change: null,
          weight_change_detail: '',
          risk_assist_level: '',
          risk_assist_deatil: '',
          motivation_behavior_change_level: '',
          motivation_behavior_change_detail: '',
          risk_severe_withdrawal_symptoms_level: '',
          risk_severe_withdrawal_symptoms_detail: ''
        }
      }
    }
  },
  watch: {
    value: {
      handler() {
        this.handleInit()
      },
      deep: true
    },
    rawData: {
      handler() {
        this.handleTransformData()
      },
      deep: true
    }
  },
  mounted() {
    this.handleInit()
  },
  methods: {
    handleInit() {
      this.rawData = this.data
    },
    handleTransformData() {
      if (this.rawData) {
        const {
          id,
          drinker_name,
          is_fill_date,
          drinker_gender,
          drinker_year,
          score,
          risk,
          motivation_behavior_change,
          is_stop_drink_in_one_year,
          low_risk_group,
          high_risk_group,
          filler_name,
          filler_relation,
          assessor_name,
          ...rest
        } = this.rawData

        this.localData.page_1 = {
          id,
          drinker_name,
          is_fill_date,
          drinker_gender,
          drinker_year,
          score,
          risk,
          motivation_behavior_change,
          is_stop_drink_in_one_year,
          low_risk_group,
          high_risk_group,
          filler_name,
          filler_relation,
          assessor_name
        }

        this.localData.page_2 = { ...rest }
      }
    },
    async printThis() {
      try {
        this.$store.dispatch('loading')
        const el = this.$refs.printcontent

        const options = {
          type: 'dataURL'
        }
        const printCanvas = await html2canvas(el, options)

        const link = document.createElement('a')
        const fileName = `self-refferal-form_${this.rawData.id || ''}.png`
        link.setAttribute('download', fileName)
        link.setAttribute(
          'href',
          printCanvas.toDataURL('image/png').replace('image/png', 'image/octet-stream')
        )
        link.click()
        this.$store.dispatch('clear_loading')
      } catch (error) {
        console.error(error)
      } finally {
        this.$store.dispatch('clear_loading')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/NongTungJai/SelfReferral/DownloadImageForm.vue